import curd from '../curd'

const BASE_PATH = '/specific/value/factor'

export default curd(BASE_PATH, {
  getAllList: () => ({
    url: `${BASE_PATH}/list`,
    method: 'GET'
  })
})



// WEBPACK FOOTER //
// ./src/apis/modules/SpecificFactor.js